module.exports = __webpack_public_path__ + "f145a1e330c7ec3a573606a8aeef4563.fbx";